import { BRAND } from "@/lib/colors";

// Categorical colours for industries. Lead with the 4 brand colours, then
// harmonious derivatives — no random Tailwind rainbow.
export const INDUSTRY_COLORS: Record<string, string> = {
  Retail: BRAND.orange,
  Government: BRAND.blue,
  Health: BRAND.green,
  Security: BRAND.red,
  Hospitality: "#C97A1F",               // deep amber, orange-family
  Education: BRAND.blueLight,           // light eagle-blue
  NFP: "#A8D88A",                       // light falcon-green
  "Aged Care": "#9E6AAB",               // soft purple, complementary
  "Construction / Mining": "#8B6914",   // earth tone
  "Transport / Logistics": "#2E5B9B",   // navy, blue-family
  "Fast Food": "#B84040",               // deep red, red-family
  Corrections: "#4A4A4A",               // charcoal neutral
  Council: "#3E8FA6",                   // teal-blue, Government sibling
  "Community Services": "#4FA383",      // jade-green, NFP sibling
  "Mental Health": "#B5568A",           // rose-mauve, Aged Care sibling
  "Utilities / Resources": "#5D7A8C",   // slate blue-grey, Construction/Mining sibling
  "Financial Services": "#B08D57",      // muted gold, Retail/Hospitality's orange family
  Insurance: "#6B6FA6",                 // muted indigo, distinct from Aged Care's purple
};

export function industryColor(name: string): string {
  return INDUSTRY_COLORS[name] ?? "#94A3B8";
}
